var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "card", attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v("plan")]),
      _vm.currentTab == 0
        ? [
            _c(
              "w-card-content",
              [
                _c("w-tabs", {
                  attrs: { tabs: _vm.tabs },
                  model: {
                    value: _vm.currentTab,
                    callback: function ($$v) {
                      _vm.currentTab = $$v
                    },
                    expression: "currentTab",
                  },
                }),
                _c(
                  "w-row",
                  [
                    _c("w-col", { attrs: { xs: "6" } }, [_vm._v(" Tier: ")]),
                    _c("w-col", { attrs: { xs: "6" } }, [
                      _vm._v(
                        " " + _vm._s(_vm.planMetadata.plan.tierName()) + " "
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c("w-col", { attrs: { xs: "6" } }, [
                      _vm._v(" payment frequency "),
                    ]),
                    _c("w-col", { attrs: { xs: "6" } }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.planMetadata.plan.paymentFrequencyName()) +
                          " "
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c("w-col", { attrs: { xs: "6" } }, [
                      _vm._v(" Max Users "),
                    ]),
                    _c("w-col", { attrs: { xs: "6" } }, [
                      _vm._v(
                        " " + _vm._s(_vm.planMetadata.plan.maxUsers) + " "
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c("w-col", { attrs: { xs: "6" } }, [
                      _vm._v(" Max Dossiers "),
                    ]),
                    _c("w-col", { attrs: { xs: "6" } }, [
                      _vm._v(
                        " " + _vm._s(_vm.planMetadata.plan.maxDossiers) + " "
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "w-scroll-view",
              { style: { flexGrow: 1 }, attrs: { tag: "w-list" } },
              _vm._l(_vm.modules, function (mod) {
                return _c(
                  "w-list-item",
                  { key: mod.id },
                  [
                    _c("w-list-item-text", [
                      _c("span", [
                        _vm._v(
                          " " + _vm._s(mod.id) + ": " + _vm._s(mod.name) + " "
                        ),
                      ]),
                    ]),
                  ],
                  1
                )
              }),
              1
            ),
          ]
        : _vm.currentTab == 1
        ? _c(
            "w-card-content",
            { style: { flexGrow: 1 } },
            [
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.currentTab,
                  callback: function ($$v) {
                    _vm.currentTab = $$v
                  },
                  expression: "currentTab",
                },
              }),
              _vm._v(" " + _vm._s(_vm.planMetadata.rawMetadata) + " "),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" Close ")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }